import ReportService from "../services/reportService";
import CodeCampaignService from "../services/codeCampaignService";
import {} from "../constants/voucherRechargeConstants";
import { REWARD_TYPES } from "../constants/bulkProcessConstant";
import { NotificationManager } from "react-notifications";

export const updatePlumProFilter = (filter) => {
  return {
    type: "UPDATE_PLUM_PRO_FILTER",
    payload: filter,
  };
};

export const updateXoxoCodeFilter = (filter) => {
  return {
    type: "UPDATE_XOXO_CODE_FILTER",
    payload: filter,
  };
};

export const updateXoxoPointFilter = (filter) => {
  return {
    type: "UPDATE_XOXO_POINT_FILTER",
    payload: filter,
  };
};

export const updateXoxoLinkFilter = (filter) => {
  return {
    type: "UPDATE_XOXO_LINK_FILTER",
    payload: filter,
  };
};

export const filterLoader = (loading) => {
  return {
    type: "UPDATE_FILTER_LOADER",
    payload: loading,
  };
};

export const updateAdminList = (adminList) => {
  return {
    type: "UPDATE_ADMIN_LIST",
    payload: adminList,
  };
};

export const updateCampaignList = (campaignList) => {
  return {
    type: "UPDATE_XOXO_CODE_CAMPAIGN",
    payload: campaignList,
  };
};

export const deleteSavedFilter =
  (activeIndex, reward_type) => (dispatch, getState) => {
    let { reportReducer } = getState();
    const rewards = [
      "xoxoPointSavedFilter",
      "xoxoCodeSavedFilter",
      "xoxoLinkSavedFilter",
      "plumProSavedFilters",
    ];
    // reportReducer[rewards[reward_type]][activeIndex].splice(index, 1);
    dispatch(filterLoader(true));
    ReportService.deleteSavedFilter(
      reward_type,
      reportReducer[rewards[reward_type - 1]][activeIndex].filter_id
    )
      .then((response) => {
        if (response && response.error == false) {
          dispatch(fetchSavedFilter(reward_type));
          // NotificationManager.success("Filter deleted successfully");
        } else {
          // NotificationManager.error("Could not delete Filter");
        }
      })
      .then(() => {
        dispatch(filterLoader(false));
      });
  };

export const fetchSavedFilter = (reward_type) => (dispatch) => {
  dispatch(filterLoader(true));
  ReportService.getSavedFilter(reward_type)
    .then((response) => {
      if (response && response.error == false && response.data) {
        switch (reward_type) {
          case REWARD_TYPES.PLUM_PRO:
            dispatch(updatePlumProFilter(JSON.parse(response.data)));
            break;
          case REWARD_TYPES.XOXO_CODE:
            dispatch(updateXoxoCodeFilter(JSON.parse(response.data)));
            break;
          case REWARD_TYPES.XOXO_POINTS:
            dispatch(updateXoxoPointFilter(JSON.parse(response.data)));
            break;
          case REWARD_TYPES.XOXO_LINK:
            dispatch(updateXoxoLinkFilter(JSON.parse(response.data)));
            break;
        }
      }
    })
    .catch((err) => {
      console.log("Err", err);
    })
    .then(() => {
      dispatch(filterLoader(false));
    });
};

export const addFilterByThunk = (params, reward_type) => (dispatch) => {
  dispatch(filterLoader(true));
  ReportService.addReportFilter(params, reward_type)
    .then((response) => {
      if (response && response.error == false) {
        dispatch(fetchSavedFilter(reward_type));
        NotificationManager.success("Filter saved successfully");
      } else {
        NotificationManager.error("Could not save Filter");
      }
    })
    .catch((Err) => {
      console.log(Err);
    })
    .then(() => {
      dispatch(filterLoader(false));
    });
};

export const fetchAdminList = () => (dispatch) => {
  const postData = {
    application_type: "stores",
    result_of: "all",
    limit: 10000,
    offset: 0,
  };
  let adminList = [];
  ReportService.getReportMultiAdminList(postData)
    .then((response) => {
      if (
        response &&
        response.success &&
        response.res &&
        response.res.length > 0
      ) {
        response.res.map((item) => {
          item["label"] = item.employee_email;
          item["value"] = item.employee_email;
          adminList.push(item);
        });
      } else {
        adminList = [];
      }
    })
    .catch((err) => {
      console.log("Error", err);
    })
    .then(() => {
      dispatch(updateAdminList(adminList));
    });
};

export const fetchCampaignList = () => (dispatch) => {
  let campaignOptions = [];
  CodeCampaignService.fetchVoucherSites()
    .then((response) => {
      if (
        response &&
        response.fetchSite &&
        response.hasOwnProperty("success") &&
        !response.success
      ) {
        campaignOptions = [];
      } else {
        response &&
          response.fetchSite &&
          response.fetchSite.data.map((item) => {
            item["label"] = item.name;
            item["value"] = item.name;
            campaignOptions.push(item);
          });
      }
    })
    .catch((err) => {
      console.log("err", err);
    })
    .then(() => {
      dispatch(updateCampaignList(campaignOptions));
    });
};
